import _ from 'lodash';

import type { FilterContext, FilterContextProvider } from 'bundles/enterprise-admin-messages/types';

const getFilterContexts = (providers: FilterContextProvider[]): FilterContext[] => {
  return _.uniq(_.flatMap(providers, (p) => p.provideFilterContexts));
};

export default getFilterContexts;
